import { createFileRoute } from "@tanstack/react-router";
import { getSearchPage } from "@/features/search/records";
import { SearchPage } from "@/features/search";
import {
  CommunityPageLoading,
  CommunityPageError,
} from "@/features/community/navigation";

export const Route = createFileRoute("/_site/$coworld/search")({
  loaderDeps: ({ search }) => ({ query: "q" in search ? search.q : undefined }),
  loader: ({ location, abortController }) =>
    getSearchPage({
      data: { href: location.href },
      signal: abortController.signal,
    }),
  head: () => ({
    meta: [
      { title: "Search · Softmax" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  pendingComponent: () => <CommunityPageLoading title="Search" />,
  errorComponent: ({ error, reset }) => (
    <CommunityPageError error={error} retry={reset} />
  ),
  component: () => <SearchPage {...Route.useLoaderData()} />,
});
